import React, { FC } from 'react'

interface NotificationProps {
  size?: number
}

const Notification: FC<NotificationProps> = ({ size = 47 }) => {
  return (
    <svg width={size} height={size * (53 / 47)} viewBox="0 0 47 53" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(-1.88 0) scale(1.08 1)">
        <path d="M21.6 6.5V4.8a1.9 1.9 0 0 1 3.8 0v1.7" stroke="#003274" strokeWidth="1.8" strokeLinecap="round" />
        <path
          d="M23.5 6.3c-8.2 0-13.2 6.6-13.2 17.2v8.7c0 4.6-1.5 7.8-4.6 10.5-1.2 1-.5 2.9 1.1 2.9h33.4c1.6 0 2.3-1.9 1.1-2.9-3.1-2.7-4.6-5.9-4.6-10.5v-8.7c0-10.6-5-17.2-13.2-17.2Z"
          fill="#309BEC"
          stroke="#003274"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
        <path
          d="M20 9.9C18.4 10.3 17.1 11.2 15.6 13.6C13.8 16.6 13.3 20.2 13.3 23.5V30.5H16.3V23.5C16.3 20.2 17.2 17.2 18.1 15C18.8 13 19.6 11.2 20 9.9Z"
          fill="#FFFFFF"
          fillOpacity="0.65"
        />
        <path
          d="M19.4 46.5c.2 3 1.8 4.8 4.1 4.8s3.9-1.8 4.1-4.8"
          fill="#309BEC"
          stroke="#003274"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export default Notification
